module.exports = __webpack_public_path__ + "static/media/video-camera.e2c178ac.svg";